import React from 'react'
import styles from './Calendar.scss'
import PropTypes from 'prop-types'
import {Month} from './Month'
import {Icon} from 'common/Icon'
import moment from 'moment'
import {getCurrentUser} from 'lib/utils'

export class Calendar extends React.PureComponent {
  static propTypes = {
    events: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired, // Takes one argument, a moment() representing the current month
    startAccessor: PropTypes.func.isRequired, // (event) => Date
    endAccessor: PropTypes.func, // (event) => Date
    date: PropTypes.instanceOf(moment).isRequired,
    currentUser: PropTypes.object, // For some date format preferences
    hideTotals: PropTypes.bool // Show/hide meta cells
  }

  static defaultProps = {
    currentUser: getCurrentUser(),
    endAccessor: () => {}
  }

  constructor (props) {
    super(props)

    this.state = {
      date: props.date || new Date()
    }
  }

  previousClicked = (e) => {
    e.preventDefault()

    const {date, onChange} = this.props
    onChange(moment(date).subtract(1, 'months').clone())
  }

  nextClicked = (e) => {
    e.preventDefault()

    const {date, onChange} = this.props
    onChange(moment(date).add(1, 'months').clone())
  }

  render () {
    const {
      events,
      startAccessor,
      endAccessor,
      toolbarLeft,
      toolbarRight,
      toolbarCenter,
      date,
      ...props
    } = this.props
    const accessors = {
      start: startAccessor,
      end: endAccessor
    }

    return (
      <div className={styles.Calendar}>
        <div className={styles.toolbar}>

          {toolbarLeft && <div className={styles.left}>
            {toolbarLeft}
          </div>}

          <div className={styles.center}>
            <a className={styles.arrow} onClick={this.previousClicked}><Icon i='arrow-back' size={31} /></a>
            <div className={styles.currentDate}>
              {toolbarCenter || date.format('MMMM YYYY')}
            </div>
            <a className={styles.arrow} onClick={this.nextClicked}><Icon i='arrow-forward' size={31} /></a>
          </div>

          {toolbarRight && <div className={styles.right}>
            {toolbarRight}
          </div>}
        </div>
        <Month
          date={date}
          events={events}
          accessors={accessors}
          {...props} />
      </div>
    )
  }
}
